import { kMaxVSpacing } from "../constants";

export class QSpacingControl {
  constructor() {
    this.fPlus = null;
    this.fMinus = null;
    this.fValueText = null;
    this.fAdder = null;
    this.fResetCmd = null;
    this.fMin = 0;
    this.fMax = kMaxVSpacing;
    this.fMapping = null;
  }

  GetValue() {
    return this.fValueText.GetValue();
  }

  GetResetCmd() {
    return this.fResetCmd;
  }

  SetShownState(showIt) {
    this.fPlus.SetShownState(showIt);
    this.fMinus.SetShownState(showIt);
    this.fValueText.SetShownState(showIt);
  }

  SetAdder(adder) {
    this.fAdder = adder;
    this.EnableControls();
  }

  SetValue(newValue) {
    this.fValueText.SetValue(newValue);
    this.EnableControls();
  }

  SetMinMax(min, max) {
    this.fMin = min;
    this.fMax = max;
  }

  EnableControls() {
    var v = this.GetValue();
    var enableMinus = true;
    var enablePlus = true;

    var dv = v - this.fAdder;
    if (dv < this.fMin) enableMinus = false;

    dv = v + this.fAdder;
    if (dv > this.fMax) enablePlus = false;

    this.fPlus.SetEnabled(enablePlus);
    this.fMinus.SetEnabled(enableMinus);
  }

  GetWidth() {
    var xLeft = this.fMinus.GetPositionX();
    var xRight = this.fPlus.GetPositionX() + this.fPlus.GetWidth();
    return xRight - xLeft;
  }

  SetMapping(mapping) {
    this.fMapping = mapping;
  }

  GetMapping() {
    return this.fMapping;
  }
}
